import React from "react";
import SummaryTop from "../../SummaryTop/Views/SummaryTop";

export const UserManagementHeader = React.forwardRef<HTMLDivElement>((props, ref) => {
  return (
    <div className="user-management-header" ref={ref}>
      <SummaryTop />
    </div>
  );
});
